import React from 'react';
import { NavLink } from 'react-router-dom';
import { useApp } from '@/context/AppContext';
import { Home, ScanLine, Package, MoreHorizontal, ArrowLeftRight } from 'lucide-react';

export const BottomNav = () => {
  const { user, can } = useApp();
  const isMgr = user?.role === 'OWNER' || user?.role === 'PARTNER' || user?.owner_access || can?.('dashboard');
  const c = (p) => !!(can && can(p));
  // Fixed, predictable mobile bar: Home | Stock | POS | Transfers | More.
  // Less-frequent actions (Dashboard, Returns, etc.) live inside "More".
  const candidates = [
    isMgr && { to: '/', label: 'Home', icon: Home, testid: 'bottom-nav-home', end: true },
    c('stock_view') && { to: '/stock', label: 'Stock', icon: Package, testid: 'bottom-nav-stock' },
    (c('billing_view') || c('billing_create')) && { to: '/billing', label: 'POS', icon: ScanLine, testid: 'bottom-nav-billing', center: true },
    c('transfer_view') && { to: '/transfers', label: 'Transfers', icon: ArrowLeftRight, testid: 'bottom-nav-transfers' },
  ].filter(Boolean);
  // "More" holds Settings, Admin, Reports, Returns, Dashboard, etc. — always reachable.
  const moreItem = { to: '/more', label: 'More', icon: MoreHorizontal, testid: 'bottom-nav-more' };
  const items = [...candidates.slice(0, 4), moreItem];
  return (
  <nav className="fixed inset-x-0 bottom-0 z-50 border-t border-slate-800 bg-slate-900/95 text-slate-400 backdrop-blur lg:hidden"
    style={{ paddingBottom: 'env(safe-area-inset-bottom, 0px)' }}>
    <div className="mx-auto flex h-16 max-w-6xl items-stretch justify-around px-1">
      {items.map((it) => {
        const Icon = it.icon;
        return (
          <NavLink key={it.to} to={it.to} end={it.end} data-testid={it.testid}
            className="relative flex flex-1 flex-col items-center justify-center gap-1 px-1">
            {({ isActive }) => (
              <>
                {/* top accent marks the active tab clearly */}
                {isActive && !it.center && <span className="absolute inset-x-4 top-0 h-0.5 rounded-full bg-primary" />}
                <span className={it.center
                  ? `flex h-10 w-10 items-center justify-center rounded-full transition-colors ${isActive ? 'bg-primary text-primary-foreground shadow-lg shadow-primary/30' : 'bg-slate-800 text-slate-200'}`
                  : `flex h-6 items-center justify-center transition-colors ${isActive ? 'text-primary' : 'text-slate-400'}`}>
                  <Icon className="h-5 w-5" />
                </span>
                <span className={`text-[11px] font-medium leading-none ${isActive && !it.center ? 'text-primary' : it.center ? 'text-slate-300' : 'text-slate-400'}`}>{it.label}</span>
              </>
            )}
          </NavLink>
        );
      })}
    </div>
  </nav>
  );
};
